import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'

import { userRegionIsEU } from '../functions/userPermissions'

const ContactInfoModal = (props) => {
  const [show, toggleShow] = useState(false)

  const currentUser = useSelector(state => state.loginReducer.currentUser)

  const handleClick = (e) => {
    e && e.preventDefault()
    toggleShow(!show)
  }

  return (
    <>
      <span onClick={handleClick}>
        {props.showModalTrigger}
      </span>

      <Modal show={show} onHide={handleClick} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>
            Contact Info
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {userRegionIsEU(currentUser) ?
            <>
              <h5 className="contact-modal-header">
                For technical support, please contact TCRS.
              </h5>

              <p className="contact-modal-text">
                <strong>Email:</strong> {' '}
                <a href="mailto:tracy.turner@tcr-solutions.com">tracy.turner@tcr-solutions.com</a>
              </p>
            </>
            :
            <>
              <h5 className="contact-modal-header">
                For technical support, please contact Genesis Research.
              </h5>

              <p className="contact-modal-text">
                <strong>Email:</strong> {' '}
                <a href="mailto:support@genesisrg.com">support@genesisrg.com</a>
              </p>
            </>
          }

          <br /><br />
          {userRegionIsEU(currentUser) ?
            <>
              <h5 className="contact-modal-header">
                For scientific support, please contact Shionogi.
              </h5>

              <p className="contact-modal-text">
                <h6>Stefano Verardi, Medical Director, Infectious Diseases</h6>
              </p>

              <p className="contact-modal-text">
                <strong>Email:</strong> {' '}
                <a href="mailto:stefano.verardi@shionogi.eu">stefano.verardi@shionogi.eu</a>
              </p>
            </>
            :
            <>
              <h5 className="contact-modal-header">
                For scientific support, please contact Shionogi.
              </h5>

              <p className="contact-modal-text">
                <h6>Bin Cai, Head Of Global Epidemiology And Real World Evidence</h6>
              </p>

              <p className="contact-modal-text">
                <strong>Email:</strong> {' '}
                <a href="mailto:Bin.Cai@shionogi.com">Bin.Cai@shionogi.com</a>
              </p>
            </>
          }

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClick}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ContactInfoModal
